import { useState } from 'react';

const STATUS_META = {
  new:       { label: 'New',       pill: '🆕' },
  hot:       { label: 'Hot',       pill: '🔥' },
  warm:      { label: 'Warm',      pill: '☀️' },
  cold:      { label: 'Cold',      pill: '❄️' },
  converted: { label: 'Converted', pill: '🏆' },
  lost:      { label: 'Lost',      pill: '⚪' },
  followup:  { label: 'Followup',  pill: '⏰' },
};

const inp = { width: '100%', padding: '9px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none', marginBottom: 10 };

export function LeadQuickAction({ lead, onSave, onClose }) {
  const [form, setForm] = useState({
    status: lead.status || 'new',
    follow_up_date: lead.follow_up_date ? lead.follow_up_date.slice(0, 10) : '',
    comment: '',
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await onSave(lead.id, form); onClose(); }
    catch (e) { alert('Error: ' + e.message); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 24, width: 400, maxWidth: '92vw', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, color: '#1a1a2e' }}>⚡ Quick Action</div>
            <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{lead.name} · {lead.phone}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
        </div>

        <label style={{ fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5 }}>Status</label>
        <select style={{ ...inp, marginTop: 6 }} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
          {Object.entries(STATUS_META).map(([k, m]) => (
            <option key={k} value={k}>{m.pill} {m.label}</option>
          ))}
        </select>

        <label style={{ fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5 }}>Follow-up Date</label>
        <input type="date" style={{ ...inp, marginTop: 6 }} value={form.follow_up_date} onChange={e => setForm({ ...form, follow_up_date: e.target.value })} />

        <label style={{ fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5 }}>Comment</label>
        <textarea style={{ ...inp, marginTop: 6, minHeight: 70, resize: 'vertical' }} placeholder="What happened on this call? (optional)" value={form.comment} onChange={e => setForm({ ...form, comment: e.target.value })} />

        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
          <button style={{ flex: 1, padding: '10px 0', background: '#f0f0f0', color: '#333', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }} onClick={onClose}>Cancel</button>
          <button style={{ flex: 1, padding: '10px 0', background: saving ? '#aaa' : '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }} onClick={save} disabled={saving}>
            {saving ? 'Saving…' : '💾 Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
